import { useContext } from 'react';
import MasterAdminContext from 'src/context/MasterAdminContext';

const useMasterAdmin = () => {
  const { users, setUsers, updateUser, addNewCreatedUser, deleteUser, adminStats, setAdminStats, homePageFilter, setHomePageFilter } = useContext(MasterAdminContext);
  return { users, setUsers, updateUser, addNewCreatedUser, deleteUser, adminStats, setAdminStats, homePageFilter, setHomePageFilter };
};

export default useMasterAdmin;
